import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { get, filter } from 'lodash';
import AddOnsRows from '../AddOnsRows/add-ons-rows';

const AddOnsSectionMobile = ({
  ssoId,
  inventory,
  currency,
  toggleModal,
  openModal,
  onModalClose,
  getInventoryItem,
  items,
  viewAddOnDetailsAction,
  editAddOnAction,
  editBookingAddOn,
  openEditBookingAddOnModal,
  masterContract,
  contract,
  addOnsSummaryLoading
}) => {
  const addOnsCalculations = get(masterContract, 'calculations.add_ons', {});
  const addOnsTotal = addOnsCalculations ? get(addOnsCalculations, 'amount') : 0;
  const hasConciergeItems = get(masterContract, 'calculations.host_add_ons_summary');

  const addOnsTaxTotal = hasConciergeItems
    ? get(masterContract, 'calculations.host_add_ons_summary.taxes', 0)
    : get(addOnsCalculations, 'taxes', 0);

  const addOnsFeeTotal = hasConciergeItems
    ? get(masterContract, 'calculations.host_add_ons_summary.fees', 0)
    : get(addOnsCalculations, 'fees', 0);

  const taxesAndFees = addOnsCalculations ? get(addOnsCalculations, 'taxes_and_fees') : 0;
  const taxesAndFeesArray = get(masterContract, 'calculations.add_on_taxes_and_fees', {});

  const taxesArray = filter(taxesAndFeesArray, (tax) => {
    return 'tax' === tax.type && !tax.is_concierge
  }, []);

  const feesArray = filter(taxesAndFeesArray, (fee) => {
    return 'fee' === fee.type && !fee.is_concierge
  }, []);

  return (
    <div className="add-ons-section-mobile d-sm-none">
      <FieldArray
        name="addOns"
        inventory={inventory}
        currency={currency}
        component={AddOnsRows}
        toggleModal={toggleModal}
        onModalClose={onModalClose}
        openModal={openModal}
        getInventoryItem={getInventoryItem}
        items={items}
        viewAddOnDetailsAction={viewAddOnDetailsAction}
        editAddOnAction={editAddOnAction}
        editBookingAddOn={editBookingAddOn}
        openEditBookingAddOnModal={openEditBookingAddOnModal}
        addOnsTotal={addOnsTotal}
        addOnsTaxTotal={addOnsTaxTotal}
        addOnsFeeTotal={addOnsFeeTotal}
        hostAddOnsSummary={get(masterContract, 'calculations.host_add_ons_summary')}
        taxesAndFees={taxesAndFees}
        taxesArray={taxesArray}
        feesArray={feesArray}
        ssoId={ssoId}
        contract={contract}
        isMobile
        addOnsSummaryLoading={addOnsSummaryLoading}
      />
    </div>
  );
};

AddOnsSectionMobile.propTypes = {
  items: PropTypes.array,
  currency: PropTypes.string,
  toggleModal: PropTypes.func,
  viewAddOnDetailsAction: PropTypes.func,
  editAddOnAction: PropTypes.func,
  openEditBookingAddOnModal: PropTypes.func,
  masterContract: PropTypes.object,
  ssoId: PropTypes.string,
  inventory: PropTypes.object,
  openModal: PropTypes.func,
  onModalClose: PropTypes.func,
  getInventoryItem: PropTypes.func,
  editBookingAddOn: PropTypes.func,
  contract: PropTypes.object,
  addOnsSummaryLoading: PropTypes.bool,
};

export default AddOnsSectionMobile;
